export default __webpack_public_path__ + "static/media/markedfordeath.8e52a760.png";